import { Typography } from '@mui/material'
import React from 'react'
import { PaperPanel } from '../Panel/PaperPanel'

interface SearchCriteriaPanelProps {
  elevation?: number
}

export const SearchCriteriaPanel: React.FC<SearchCriteriaPanelProps> = ({
  elevation = 3
}) => {
  return (
    <PaperPanel centerText elevation={elevation}>
      <Typography variant='button'>
        Ajuste los criterios de busqueda y presione el botón buscar.
      </Typography>
    </PaperPanel>
  )
}
